import { formInputSx } from '../../styles/Global.style';

export const slotProps = (theme, formik, togglePicker) => ({
  textField: {
    variant: 'outlined',
    error: Boolean(formik.errors.date),
    helperText: formik.errors.date,
    onKeyDown: togglePicker,
  },
  openPickerButton: {
    onClick: togglePicker,
  },
  popper: {
    placement: 'bottom-end',
    sx: {
      '.MuiPickersArrowSwitcher-button': {
        color: theme.palette.tertiary.main,
      },
      '.MuiDayCalendar-weekDayLabel': {
        color: theme.palette.tertiary.main,
        fontWeight: 700,
      },
      '.MuiPickersCalendarHeader-switchViewIcon': {
        color: theme.palette.tertiary.main,
        fontWeight: 700,
      },
      '.MuiPickersPopper-paper ': {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: '5px',
      },
      '.MuiPickersDay-root': {
        color: theme.palette.secondary.main,
      },
      '.MuiButtonBase-root': {
        '&:focus': {
          backgroundColor: theme.palette.tertiary.main,
          fontWeight: 700,
        },
      },
      '.Mui-selected': {
        backgroundColor: `${theme.palette.tertiary.main} !important`,
        fontWeight: 700,
      },
      '.Mui-disabled': {
        color: `${theme.palette.accent.secondary} !important`,
      },
      '.MuiPickersDay-today': {
        border: `1px solid ${theme.palette.secondary.main} !important`,
      },
    },
  },
});

export const datePickerSx = (theme) => ({
  ...formInputSx(theme),
  color: theme.palette.secondary.main,
  width: '100%',
  '.MuiSvgIcon-root': {
    fill: theme.palette.tertiary.main,
  },
  '.MuiInputLabel-root': {
    color: theme.palette.secondary.main,
  },
  '.MuiFormLabel-root.Mui-focused': {
    color: theme.palette.secondary.main,
  },
  '.Mui-focused': {
    color: theme.palette.secondary.main,
  },
});
